import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { ModalBodyContent, ModalButtonsContainer, ModalHeader, StyledModalBody, StyledModalV2 } from '../../../components/Modals';
import { ButtonBodyVariant } from '../../../components/ui/ButtonVariant';
import { closeActiveModal } from '../../../helper/modals';
import { setToast } from '../../../redux/actions/window';
import { InfoSection, UserInfo } from '../IntercomComponents';
import { formatPhoneNumber } from '../../../helper/phoneNumber';
import { deleteIntercomUser, searchIntercomUsers } from '../../../redux/actions/intercom';
import { requestPending } from '../../../utils/status';
import { DELETE_INTERCOM_USER } from '../../../redux/constants';

const DeleteIntercomUserModal = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const { modal, data: { query, intercomUser } } = useSelector((state) => state.headerModal);
  const globalSelectedBuilding = useSelector((state) => state.building.globalSelectedBuilding);
  const globalOrgId = useSelector((state) => state.Organization.globalOrgId);
  const deleteIntercomUserStatus = useSelector((state) => state.intercom.deleteIntercomUserStatus);

  const deleteUser = () => {
    dispatch(
      deleteIntercomUser({
        orgId: globalOrgId,
        buildingId: globalSelectedBuilding?.id,
        userId: intercomUser.user_id,
        success: () => {
          dispatch(
            setToast({
              toastShow: true,
              toastMessage: t('Successfully deleted user from the intercom')
            })
          );
          dispatch(searchIntercomUsers({
            orgId: globalOrgId,
            buildingId: globalSelectedBuilding.id,
            queryString: query,
          }))
          closeActiveModal();
        },
        fail: () => {
          dispatch(
            setToast({
              toastShow: true,
              toastMessage: t('Failed to delete user from the intercom'),
              modal: 'errorToast'
            })
          );
        }
      })
    );
  }

  return (
    <StyledModalV2
      show={modal === 'DeleteIntercomUserModal'}
      onClose={closeActiveModal}
      closeOnBackdrop={false}
      width={'550px'}
      side
    >
      <StyledModalBody>
        <ModalHeader v2 title={`${t('Delete user confirmation')}`} />
        <ModalBodyContent>
          <InfoSection
            title={t('Are you certain you want to delete this user?')}
            subtitle={t('Doing so will remove this user from the intercom')}
          >
            <UserInfo title={t("Display Name")} value={intercomUser?.display_name} />
            <UserInfo title="Phone Number" value={formatPhoneNumber(intercomUser.phone_number)} />
            {intercomUser?.private_pin && (
              <UserInfo title={t("Private pin")} value={intercomUser.private_pin} />
            )}
          </InfoSection>
        </ModalBodyContent>
      </StyledModalBody>

      <ModalButtonsContainer gapY="8px" isAtBottom>
        <ButtonBodyVariant onClick={deleteUser} cssOverride={"width: 100%;"} disabled={deleteIntercomUserStatus === requestPending(DELETE_INTERCOM_USER)}>{t('Delete User')}</ButtonBodyVariant>
      </ModalButtonsContainer>
    </StyledModalV2 >
  );
};

export default DeleteIntercomUserModal;
